import type { ShapeProps } from "./index";

export function Rectangle({ width, height, ...svgAttributes }: ShapeProps) {
  const r = Math.min(8, width * 0.1, height * 0.1);
  return (
    <rect width={width} height={height} rx={r} ry={r} {...svgAttributes} />
  );
}
